/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING : STYLES --------------- ++++++++++ */
export default theme => ({
    commenting: {
        minHeight: replacePXinStringWithEM('calc(100vh - 185px)'),
    },

    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thinnest]: {
        commenting: {
            textAlign: 'center',
            display: 'block',
            '& .name-sites': {
                marginTop: pxToEm(25)
            }
        }
    }
});
